import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Search, Type } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Footer } from "../components/Footer";
import { CompactHeader } from "../components/CompactHeader";
import * as Constants from "../../constants";
import BackLoader from "../../components/backloader";

export default function VerificationHighCourt() {
  const location = useLocation();
  // Use explicit typing for useState
  const [applicationType, setApplicationType] = useState("");
  const [referenceNumber, setReferenceNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const query = location.pathname.replace(/^\/search\//, "");
  // Use React.FormEvent<HTMLFormElement> to type the event object
  useEffect(() => {
    if (query != null && !query.startsWith("/VerificationHighCourt")) {
      onPublicSearch(query);
      setReferenceNumber(query);
    }
  }, [query]);
  const onPublicSearch = async (qr) => {
    //this to continue the process for cases that looks like it
    setLoading(true);
    const sear = { documentId: qr };
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/report/document-verification`,
        {
          method: "POST",
          body: JSON.stringify(sear),
          headers: {
            "Content-Type": "application/json, text/plain",
          },
        }
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code === 0) {
        setResult(data.doc);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      // setErr(Constants.serverErr);
      // onMove();
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Verifying:", { applicationType, referenceNumber });
    // In future: fetch verification result here (API call)

    // NOTE: You can add basic validation here
    if (!referenceNumber.trim()) {
      alert("Please  enter a Reference Number.");
      return;
    }

    // Logic to set a loading state or display results would go here
    onPublicSearch(referenceNumber);
  };

  return (
    <section className="bg-gray-50 dark:bg-gray-800 min-h-screen">
      <CompactHeader />
      {/* Header Section */}
      <section className="relative py-24 bg-hero-light-image dark:bg-hero-dark">
        {/* <div className="absolute inset-0 bg-black/20"></div> */}
        <div className="container mx-auto px-4 sm:px-6 max-w-7xl relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              Verification – High Court
            </h1>
          </div>
        </div>
      </section>
      <div className="container mx-auto px-4 py-4 sm:px-6 max-w-6xl">
        {/* Verification Platform Card */}
        <div className="bg-white dark:bg-gray-700 shadow-lg rounded-md border border-gray-200 dark:border-gray-600">
          <div className="p-6">
            {/* Form */}
            <form
              onSubmit={handleSubmit}
              className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center mb-6"
            >
              {/* Select Application Type */}
              {/* <div>
                <label className="block text-gray-700 dark:text-gray-300 font-medium mb-2">
                  Select Application Type
                </label>
                <select
                  value={applicationType}
                  onChange={(e) => setApplicationType(e.target.value )} // Cast value to ApplicationType
                  className="w-full border border-gray-300 dark:border-gray-500 rounded-md px-4 py-2 text-gray-900 dark:text-gray-100 dark:bg-gray-800 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  <option value="">Select Application Type</option>
                  <option value="Affidavit">Affidavit</option>
                  <option value="filing-details">External Affidavit</option>
                  <option value="Forms-Letters">Forms and Letters</option>
                  <option value="CTC">CTC</option>
                </select>
              </div>
 */}
              {/* Reference Number Input */}
              <div>
                <label className="block text-gray-700 dark:text-gray-300 font-medium mb-2">
                  Enter Reference Number/ Affidavit ID
                </label>
                <div className="flex">
                  <input
                    type="text"
                    value={referenceNumber}
                    onChange={(e) => setReferenceNumber(e.target.value)}
                    placeholder="Enter Reference Number"
                    className="flex-grow border border-gray-300 dark:border-gray-500 rounded-l-md px-4 py-2 text-gray-900 dark:text-gray-100 dark:bg-gray-800 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                  <button
                    type="submit"
                    className="bg-orange-500 hover:bg-orange-600 text-white font-medium px-6 rounded-r-md transition-colors"
                  >
                    View
                  </button>
                </div>
              </div>
            </form>

            {/* Results Box */}
            <div className="border border-gray-300 dark:border-gray-600 rounded-md min-h-[200px] bg-white dark:bg-gray-800 p-4">
              {/* Placeholder for verification result */}
              {result == null && (
                <p className="text-gray-500 dark:text-gray-400 italic">
                  Verification results will appear here...
                </p>
              )}
              {result != null && (
                <p className="text-gray-500 dark:text-gray-400 italic">
                  Document with title <strong>{result.documentTitle}</strong>
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <BackLoader open={loading} />
    </section>
  );
}
